<label class="checkbox" [class.disabled]="disabled">
  <riv-checkbox
    *ngIf="!subvertText"
    [identifier]="identifier"
    [name]="name"
    [disabled]="disabled || subvertBox"
    [indeterminate]="indeterminate"
    [value]="value"
    (valueChange)="valueChange.emit($event)"
    (click)="$event.stopPropagation()"
  ></riv-checkbox>
  <div *ngIf="subvertText">
    <span class="subvert-text">{{ subvertText }}</span>
  </div>
  <div class="label">
    <ng-content></ng-content>
  </div>
</label>
